import { OAuthConfig } from '@doka/identity-login';

export const environment = {
  production: false,
  stage: 'dev',
  baseUrlGroupIdentityAPI: 'https://login.test.doka.com',
  apiBaseUrl: 'https://azwe-app-dev-invest.azurewebsites.net',
};

export const authCodeFlowConfig: OAuthConfig = {
  issuer: 'https://login.test.doka.com',
  strictDiscoveryDocumentValidation: false,
  clientId: 'ac7ed73e-a48f-453a-bfe9-ac7df6bbfb32',
  responseType: 'code',
  scope: 'openid profile email offline_access investtool.doka.com/invest',
  oidc: true,
  showDebugInformation: false,
  logoutUrl: 'https://login.test.doka.com/connect/endsession',
  tokenEndpoint: 'https://login.test.doka.com/connect/token',
  redirectUri: `${window.location.origin}/authentication/callback`,
  silentRefreshRedirectUri: `${window.location.origin}/authentication/silent-callback`,
};
